import { MyListPage } from "./MyListPage";

export default MyListPage;
